export default {
  lesson: { type: 'lesson', title: 'lessonCheckout' },
  material: { type: 'material', title: 'materialCheckout' },
  seminar: { type: 'seminar', title: 'seminarCheckout' },
};
